export const SECONDS_PER_DAY = 24 * 60 * 60;

export const FLOW_STEP_ALLOWED_FIELDS = [
    'id',
    'lang',
    'name',
    'type',
    'i18n',
    'anonymous_info',
    'video_interview_data',
    'locks_application',
];

export function convertAvailableFlows(flows) {
    if (!flows || !flows.length) {
        return {};
    }
    return flows.reduce((acc, flow) => {
        acc[flow.value] = {
            name: flow.label,
            steps: [],
            id: flow.value,
            disabled: flow.disabled !== '',
        };
        return acc;
    }, {});
}

export function transformPlanFromApi(plan) {
    return planSecondsToDisplayDays(plan);
}

/**
 * After PATCH, convert the plan map we sent (seconds) back to days for editor state.
 */
export function planSecondsToDisplayDays(planMap) {
    if (!planMap || typeof planMap !== 'object') {
        return {};
    }
    return Object.entries(planMap).reduce((acc, [key, val]) => {
        acc[key] = { ...val };
        if (val.target_lead_time != null) {
            acc[key].target_lead_time = val.target_lead_time / SECONDS_PER_DAY;
        }
        return acc;
    }, {});
}

export function cleanFlowStep(step) {
    const cleanStep = {};
    FLOW_STEP_ALLOWED_FIELDS.forEach((field) => {
        if (field in step) {
            cleanStep[field] = step[field];
        }
    });
    return cleanStep;
}

export function extractPlanAndCleanedFlowFromSteps(flowSteps) {
    const plan = {};
    const cleanedFlow = flowSteps.map((step) => {
        const planForStep = {};
        if (step.deadline) {
            planForStep.deadline = step.deadline;
        }
        if (step.target_lead_time != null && step.target_lead_time !== '') {
            planForStep.target_lead_time = Number(step.target_lead_time) * SECONDS_PER_DAY;
        }
        if ('deadline' in planForStep || 'target_lead_time' in planForStep) {
            plan[step.id] = planForStep;
        }
        const { deadline, target_lead_time, ...rest } = step;
        return cleanFlowStep(rest);
    });
    return { plan, cleanedFlow };
}

export function buildPlanPatchRequestBody(formData) {
    const { plan, cleanedFlow } = extractPlanAndCleanedFlowFromSteps(formData.flow);
    return {
        name: formData.name,
        flow: cleanedFlow,
        plan,
    };
}

export const getStepVideoInterviewQuestionsCount = (step) =>
    Object.keys(step?.video_interview_data?.interview_form?.propertiesHints || {}).length || 0;

export const getFlowVideoInterviewQuestionsCount = (flow) =>
    (flow?.steps ?? [])
        .filter((step) => step.type === 'TaVideoInterview')
        .reduce((total, step) => total + getStepVideoInterviewQuestionsCount(step), 0);